module.exports = __webpack_public_path__ + "assets/img/5.80fde67d.png";